// extracted by mini-css-extract-plugin
export default {"bannerSection":"Hero_bannerSection__ankRN","content":"Hero_content__ARqEN"};